import { AgentDeploymentDetails } from "healthex-common/agentdeployment.dtos";
import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
import { plainToInstance } from "class-transformer";
export class DeploymentService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getAgentUpgradeDetails(orgId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/organizations/:orgId/agent/upgrade", { orgId }), authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(AgentDeploymentDetails, response.data);
    }
    async triggerAgentUpgrade(orgId) {
        await axios.post(generateURL(this.environment.API_BASE_URL, "/organizations/:orgId/agent/upgrade", { orgId }), {}, authenticatedApiConfig(this.authenticationProvider));
    }
    async triggerAgentLogUpload(orgId, input) {
        await axios.post(generateURL(this.environment.API_BASE_URL, "/organizations/:orgId/agent/logupload", { orgId }), input, authenticatedApiConfig(this.authenticationProvider));
    }
}
